// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fyBtn[data-v-33b9582f] {\r\n\tdisplay: inline-block;\r\n\twidth: 20px;\r\n\tposition: absolute;\r\n\ttop: -10px;\r\n\tright: -28px;\r\n\tcursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
